<template>
  <div>

    <div class="copyright gray-back  linehei2">
      <div>
        <span><router-link to="/help">常见问题</router-link></span>
        <span><router-link to="/xieyi">用户协议</router-link></span>
        <span><router-link to="/yinsi">隐私政策</router-link></span>
        <span><router-link to="/guifan">内容管理规范</router-link></span>
        <span><router-link to="/apidoc">api接口文档</router-link></span>
      </div>

      <div class="foot_0" style="display: none;">Copyright © 2020  版权所有</div>
      <div class="foot_1" style="display: none;">Copyright © 2020 版权所有 </div>
      <div class="foot_2" style="display: none;">Copyright © 2020 版权所有 版权所有</div>
      <div class="foot_3" style="display: none;">Copyright © 2020 版权所有 版权所有</div>
      <div class="foot_4" style="display: none;">Copyright © 2020 版权所有 版权所有</div>
      <div class="foot_5" style="display: none;">Copyright © 2020 版权所有</div>
      <div class="foot_6" style="display: none;">Copyright © 2020  版权所有 </div>


    <div>


      免责声明：短网址链接全部由访客自主生成，所跳转网页内容与本站无关!<br>

    </div>
      <div style="height: 40px;"></div>

    <div>
    </div>
    </div>


<!--    <div class="float-nav-box">-->

<!--    <div class="div-box line-bottom">-->
<!--      <i class="iconfont icongongzhonghao"></i><br>-->
<!--      <span>关注公众号</span>-->
<!--      <div class="gzh-qrcode qrcode-box">-->
<!--        <div class="img-box">-->
<!--          <img src="../assets/images/index/1568964307.png">-->
<!--          <div>官方公众号</div>-->
<!--        </div>-->
<!--        <span></span>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="div-box line-bottom">-->
<!--      <i class="iconfont iconweixin1"></i><br>-->
<!--      <span>客服飞机</span>-->
<!--      <div class="kf-qrcode qrcode-box">-->
<!--        <div class="img-box">-->
<!--          <img src="../assets/images/index/1568965109.png">-->
<!--          <div>客服微信号</div>-->
<!--        </div>-->
<!--        <span></span>-->
<!--      </div>-->
<!--    </div>-->


<!--    <div class="div-box">-->
<!--      <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3683390325&site=qq&menu=yes">-->
<!--        <i class="iconfont icon-dwzQQ"></i><br>-->
<!--        <span>联系客服</span>-->

<!--      </a>-->
<!--    </div>-->
<!--    </div>-->

  </div>
</template>

<script>
export default {
  name: "Foot",
  components: {
  },
  data(){

    return {

    };
  },
  mounted() {
  },
  methods:{

  }
}
</script>

<style>
.copyright{width:1200px;height:140px;padding-top:40px;text-align:center;margin:0 auto;color:#666666}
.copyright div{width:100%;height:14px;font-size:14px;margin-bottom:25px}
.copyright div span{display:inline-block;padding:0 10px}
.copyright div span a{color:darkblue}
</style>